import { gql } from '@apollo/client';
const GET_SPECIFICATION_PRODUCTION_MANAGER_DETAILS = gql `
  query GetSpecificationProductionManagerDetails($orderId: ID!, $specificationId: ID!) {
    specificationProductionManagerDetails(orderId: $orderId, specificationId: $specificationId) {
      specification {
        id
        itemCode
        fancyName
        description
      }
      orderModels {
        id
        shortName
        fullName
        modelReady
      }
      components {
        component {
          id
          name
          productCategory {
            id
            typeLabelPL
            typeLabelEN
          }
        }
        componentVariants {
          id
          name
          color
          calculatedConsumption
          consumptionOverride
          confirmedConsumption
          componentAttributesPL
          variantAttributesPL
          componentAttributesEN
          variantAttributesEN
          ready
          collectedQuantity
          requiredConsumption(specificationId: $specificationId)
          allocatedQuantity(specificationId: $specificationId)
          availableQuantity(specificationId: $specificationId)
          supplier {
            id
            supplier {
              id
              shortName
            }
          }
          orderOperatorOfOrder {
            id
            orderOperator {
              id
              name
            }
          }
          componentCategory {
            id
            consumptionType {
              labelPL
              labelEN
            }
            typeLabelPL
            typeLabelEN
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_PRODUCTION_MANAGER_DETAILS;
